var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-i-3"},[_c('div',{staticClass:"i-3-1"},[_vm._v("让我了解您的需求，为您提供免费方案")]),_c('div',{staticClass:"i-3-2",on:{"click":_vm.demand}},[_vm._v("获取方案")])])])}
var staticRenderFns = []

export { render, staticRenderFns }